import { LogLevel } from './log-level';

export class Log {

    constructor(
        public readonly level: LogLevel,
        public readonly msg: any,
        public readonly error: any = null,
        public readonly date: Date = new Date()) {
    }

}
